export default "__VITE_ASSET__MZYHY5uS__"